import { render } from "./DashboardGenerico.vue?vue&type=template&id=54baa259&scoped=true"
import script from "./DashboardGenerico.vue?vue&type=script&lang=js"
export * from "./DashboardGenerico.vue?vue&type=script&lang=js"

import "./DashboardGenerico.vue?vue&type=style&index=0&id=54baa259&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54baa259"]])

export default __exports__